module.exports = __webpack_public_path__ + "img/reserveone.ec059f1c.png";